var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c("div", { staticClass: "sidebar" }, [
        _c("h4", [_vm._v("Invite Codes:")]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.codes, function(code) {
            return _c("li", { key: code.id }, [
              _c("span", [_vm._v(_vm._s(code.value))]),
              _vm._v(" "),
              _vm._m(0, true)
            ])
          })
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detail" },
        [
          _c("div", [
            _c(
              "span",
              {
                on: {
                  click: function($event) {
                    _vm.showCreate = true
                  }
                }
              },
              [_vm._v("Create")]
            )
          ]),
          _vm._v(" "),
          _c("aGrid", {
            staticStyle: { width: "100%" },
            attrs: { rows: _vm.attendees },
            on: { rowselected: _vm.setSelected }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDetail
        ? _c("attendeeDetail", {
            attrs: { attendee: _vm.selected },
            on: {
              close: function($event) {
                _vm.showDetail = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showCreate
        ? _c("attendeeCreate", {
            attrs: { eventid: _vm.id },
            on: {
              close: function($event) {
                _vm.showCreate = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "fas fa-times" })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bc7ec38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bc7ec38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/attendees.vue
// module id = Jmf0
// module chunks = 1